<template lang="html">
	<ag-table class="conseillers-table" :columns="columnDefs" :rows="rowDataFiltered" :customOptions="tableOptions" @cellclick="handleCellClick"></ag-table>
</template>

<script>
import AgTable from '@/common/components/ag-table'
import { ROLES } from '@/utils/constants'
export default {
	name: 'Activity',
	props: ['elements', 'clickable'],
	components: {
		AgTable
	},
	data () {
		return {
			columnDefs: null,
			rowData: this.elements,
			tableOptions: {
				pagination: false,
				headerHeight: 30,
				rowHeight: 44,
			}
		}
	},
	beforeMount () {
		this.columnDefs = [
			{ name: 'Pic-id', field: 'media', cellType: 'roundImg', width: 80, cellClass: 'cell-center' },
			{ name: 'Nom', field: 'name', width: 150 },
			{ name: 'Cabinet', field: 'office.name', width: 120 },
			{ name: 'E-mail', field: 'email', cellType: 'light', width: 200 },
			{ name: 'Téléphone', field: 'phone', cellType: 'light', width: 120 },
			{ name: 'Adresse', field: 'address', cellType: 'light', width: 150 },
			{ name: 'Ville', field: 'city', cellType: 'light', width: 120 },
			{ name: 'Pays', field: 'country', cellType: 'light', width: 100 },
			{ name: 'Role', field: 'role', cellType: 'light', width: 120 },
			{ name: 'Statut', field: 'enabled', cellType: 'statusAvailable', width: 90 }
		]
	},
	methods: {
		handleCellClick (e) {
			if (e.colDef.headerName === 'Statut') {
				this.$emit('statuschange', e)
			} else if (this.clickable && e.data && e.data.id) {
				this.$router.push({name: 'ConseillersDetails', params: {id: e.data.id}})
			}
		}
	},
	computed: {
		rowDataFiltered () {
			return this.elements.map(conseiller => {
				let role = '';
				const found = ROLES.find(role => conseiller.roles[0] === role.key);
				if (found) {
					role = found.label;
				}

				return ({
					...conseiller,
					name: `${conseiller.first_name} ${conseiller.last_name}`,
					role
				});
			})
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ConseillersTable.vue?9d01e62a